import { Augmentation } from "./Augmentation";

export const StaticAugmentations: Record<string, Augmentation> = {};
